import styles from "@chatscope/chat-ui-kit-styles/dist/default/styles.min.css";
import React, { useEffect, useState, useRef, useMemo } from "react";
import config from "../../config";
import { db } from "../../repository/firebase_init";
import { collection, onSnapshot, doc, updateDoc } from "firebase/firestore";
import { MessageSeparator } from "@chatscope/chat-ui-kit-react";
import { format } from "date-fns";
import { FaPlus } from "react-icons/fa6";
import { FaImage } from "react-icons/fa6";
import { IoMdSend } from "react-icons/io";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { storage } from "../../repository/firebase_init";
import backgroundImage from "../../Images/wallapaper.jpeg";
import DataTable from "react-data-table-component";
import { Dropdown } from "primereact/dropdown";
import axios from "axios";

export default function Complaints() {
  const [complaints, setComplaints] = useState([]);
  // const [filteredComplaints, setFilteredComplaints] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchField, setSearchField] = useState("contact");
  const [selectedComplaint, setSelectedComplaint] = useState(null);
  const [newComment, setNewComment] = useState("");
  const [openImageVideoUpload, setOpenImageVideoUpload] = useState(false);
  const [instantMsges, setInstantMsges] = useState([]);
  const [selectedInstantMsg, setSelectedInstantMsg] = useState({});
  // const apiUrl = "https://webai-forex-backend-ashy.vercel.app/api/notice";

  const [isModalOpen, setIsModalOpen] = useState(false);
  const { API_URL } = config;

  const messagesEndRef = useRef(null);
  const modalOpenRef = useRef(false);
  const img =
    "https://firebasestorage.googleapis.com/v0/b/nukkad-foods.appspot.com/o/chat-images%2F1731140189032-young-manager-wearing-a-black-t-shirt-in-a-cafe-fa.png?alt=media&token=c23b9ea3-694c-436a-92df-0874e9ef6a63";
  const filteredComplaints = useMemo(() => {
    if (!searchTerm) return complaints;
    return complaints.filter((complaint) =>
      complaint[searchField].toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [searchTerm, searchField, complaints]);

  useEffect(() => {
    const unsubscribe = onSnapshot(
      collection(db, "chat"),
      (snapshot) => {
        const data = snapshot.docs.map((doc) => ({
          contact: doc.id,
          data: doc.data(),
          lastModified: doc.data().lastModified.seconds * 1000,
        }));
        const sortedData = data.sort((a, b) => b.lastModified - a.lastModified);
        setComplaints(sortedData);
        setLoading(false);
      },
      (error) => {
        console.error("Error fetching complaints:", error);
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const fetchInstantMessages = async () => {
      try {
        const response = await axios.get(
          "http://localhost:5000/api/message/getAllMessages"
        );
        if (response.data?.messages) {
          const formattedNotices = response.data.messages.map((notice) => ({
            id: notice._id,
            msg: notice.message,
          }));
          setInstantMsges(formattedNotices);
          //   console.log("Formatted messages: ", formattedNotices);
        }
      } catch (error) {
        console.error("Error fetching instant msges:", error);
      }
    };

    fetchInstantMessages();
  }, []);
  useEffect(() => {
    if (selectedComplaint) {
      const unsubscribe = onSnapshot(
        doc(db, "chat", selectedComplaint.contact),
        (doc) => {
          if (doc.exists()) {
            const data = doc.data();
            // Update selectedComplaint with the latest messages
            setSelectedComplaint((prev) => ({
              ...prev,
              messages: data.messages || [], // Update messages in selectedComplaint
            }));
          }
        }
      );

      return () => unsubscribe();
    }
  }, [selectedComplaint]);
  useEffect(() => {
    console.log("selectedComplaint updated:", selectedComplaint);
    const updateCount = async () => {
      await updateComplaint("", "", "", true);
    };
    if (selectedComplaint) {
      updateCount();
    }
  }, [selectedComplaint]);
  useEffect(() => {
    const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
    const handleScroll = async () => {
      await delay(1000);
      if (messagesEndRef.current) {
        document.getElementById("allmessagesclick").click();
      }
    };
    setTimeout(() => {
      handleScroll();
    }, [1600]);
  }, [messagesEndRef.current]);
  useEffect(() => {
    const fetchInstantMessages = async () => {
      try {
        const response = await axios.get(
          API_URL + "/api/message/getAllMessages"
        );
        if (response.data?.notices) {
          const formattedNotices = response.data.notices.map((notice) => ({
            id: notice._id,
            msg: notice.title,
          }));
          setInstantMsges(formattedNotices);
        }
      } catch (error) {
        console.error("Error fetching instant msges:", error);
      }
    };

    fetchInstantMessages();
  }, []);
  const handleSearchTermChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleSearchFieldChange = (event) => {
    setSearchField(event.target.value);
  };

  const handleViewComplaint = async (complaint) => {
    setSelectedComplaint({
      ...complaint.data,
      contact: complaint.contact,
      lastModified: complaint.lastModified,
    });
    console.log("Complain data: ", complaint.data);
    setNewComment("");
    setIsModalOpen(true); // Set modal open state
  };

  const handleModalClose = () => {
    setIsModalOpen(false); // Reset modal open state
    setSelectedComplaint(null);
  };

  const handleSendComment = async () => {
    if (selectedComplaint) {
      setNewComment("");
      await updateComplaint(
        selectedComplaint.contact,
        newComment,
        "In Progress",
        true
      );
      messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };
  const updateComplaint = async (id, comment, status, markAsRead = false) => {
    if (!id) {
      console.error("Invalid document ID.");
      return;
    }
    // console.log('id is update complaint :', id)

    try {
      const complaintRef = doc(db, "chat", id);
      const newMessage = {
        sender: "nukkad_admin",
        text: comment,
        type: "text",
        timeStamp: {
          seconds: Math.floor(Date.now() / 1000),
          nanoseconds: 0,
        },
      };

      // Ensure selectedComplaint is defined and has messages
      if (!selectedComplaint || !selectedComplaint.messages) {
        console.error("Selected complaint is not valid:", selectedComplaint);
        return;
      }

      const updateData = {
        messages: [...selectedComplaint.messages, newMessage],
        lastModified: {
          seconds: Math.floor(Date.now() / 1000),
          nanoseconds: 0,
        },
        ...(markAsRead && { unreadBySupport: 0 }),
      };

      console.log("Updating complaint with data:", updateData);
      await updateDoc(complaintRef, updateData);
      console.log("Complaint updated successfully");
    } catch (error) {
      console.error("Error updating complaint:", error);
    }
  };
  const updateDropDownComplaint = async (
    row,
    comment,
    status,
    markAsRead = false
  ) => {
    // console.log('Row: ', row.data.messages)
    try {
      const complaintRef = doc(db, "chat", row.contact);
      const newMessage = {
        sender: "nukkad_admin",
        text: comment,
        type: "text",
        timeStamp: {
          seconds: Math.floor(Date.now() / 1000),
          nanoseconds: 0,
        },
      };
      const updateData = {
        messages: [...row.data.messages, newMessage],
        lastModified: {
          seconds: Math.floor(Date.now() / 1000),
          nanoseconds: 0,
        },
        ...(markAsRead && { unreadBySupport: 0 }),
      };

      console.log("Updating complaint with data:", updateData);
      await updateDoc(complaintRef, updateData);
      alert("Message sent successfully");
    } catch (error) {
      console.error("Error updating complaint:", error);
    }
  };

  if (loading) {
    return (
      <div
        className="d-flex flex-column bg-white"
        style={{
          height: "100vh",
          maxWidth: "100vw",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div className="spinner-grow text-success" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }
  const isUserMessage = (sender) => {
    const phoneRegex =
      /^\+?(\d{1,4})?[-.\s]?(\(?\d{3}\)?)[-.\s]?\d{3}[-.\s]?\d{4}$/;
    return phoneRegex.test(sender);
  };
  const handleUploadImageVideoOpen = () => {
    setOpenImageVideoUpload((preve) => !preve);
  };
  const updateMediaComplaint = async (
    id,
    comment,
    status,
    markAsRead = false
  ) => {
    try {
      const complaintRef = doc(db, "chat", id);
      const updateData = {
        messages: [...selectedComplaint.messages, comment],
        lastModified: {
          seconds: Math.floor(Date.now() / 1000),
          nanoseconds: 0,
        },
        ...(markAsRead && { unreadBySupport: 0 }),
      };
      await updateDoc(complaintRef, updateData);
      // setSelectedComplaint(null);
    } catch (error) {
      console.error("Error updating complaint:", error);
    }
  };
  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      try {
        const downloadUrl = await uploadImage(file);
        const newMessage = {
          sender: "nukkad_admin", // Replace with the user's phone number if applicable
          text: file.name, // Store the filename in the text field
          timeStamp: {
            seconds: Math.floor(Date.now() / 1000),
            nanoseconds: 0,
          },
          type: "file", // Indicate that this is a file message
          filename: file.name, // Store the original filename
          downloadUrl: downloadUrl, // The URL for downloading the file
        };
        await updateMediaComplaint(
          selectedComplaint.contact,
          newMessage,
          "In Progress",
          true
        );
        setOpenImageVideoUpload(false);
      } catch (error) {
        console.error("Error uploading image/video:", error);
      }
    }
  };
  const uploadImage = async (file) => {
    const imageName = `chat-images/${Date.now()}-${file.name}`;
    const imageRef = ref(storage, imageName);
    await uploadBytes(imageRef, file);
    return await getDownloadURL(imageRef);
  };
  const columns = [
    {
      name: "Contact",
      selector: (row) => row.contact,
      sortable: true,
      width: "180px",
    },
    {
      name: "Last Modified",
      selector: (row) => new Date(row.lastModified).toLocaleString(),
      sortable: true,
    },
    {
      name: "Unread Messages",
      selector: (row) => row.data.unreadBySupport,
      sortable: true,
    },
    {
      name: "Action",
      cell: (row) => (
        // <button
        //     className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2 active:bg-blue-700 transition-all duration-200"
        //     onClick={() => setSelectedRequest(row)}
        // >
        //     View
        // </button>
        <button
          className="btn btn-primary btn-sm"
          onClick={() => handleViewComplaint(row)}
          data-bs-toggle="modal"
          data-bs-target="#complaintModal"
        >
          Respond
        </button>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
    },
    {
      name: "Instant Reply",
      cell: (row) => (
        <Dropdown
          value={selectedInstantMsg[row._id] || null}
          onChange={(e) =>
            updateDropDownComplaint(row, e.value.msg, "In Progress", true)
          } // Update the selected city for this row
          options={instantMsges}
          optionLabel="msg"
          placeholder="send a msg"
          className="w-full md:w-14rem h-8 items-center pl-2"
          panelClassName="bg-white border border-gray-300 shadow-lg p-2"
        />
      ),
      sortable: true,
    },
  ];
  const customStyles = {
    headCells: {
      style: {
        backgroundColor: "#1F2937",
        fontWeight: "bold",
        color: "#F9FAFB",
        fontSize: "16px",
        textTransform: "uppercase",
        padding: "14px",
        borderBottom: "2px solid #E5E7EB",
      },
    },
    cells: {
      style: {
        padding: "8px",
        color: "#4B5563",
        fontSize: "17px",
        borderBottom: "1px solid #E5E7EB",
      },
    },
    rows: {
      style: {
        minHeight: "50px",
        backgroundColor: "#FFFFFF",
        "&:hover": {
          backgroundColor: "#F3F4F6",
          transition: "background-color 0.2s ease-in-out",
        },
        "&:not(:last-of-type)": {
          borderBottom: "1px solid #E5E7EB",
        },
      },
      highlightOnHoverStyle: {
        backgroundColor: "#E5E7EB",
        borderRadius: "6px",
        outline: "1px solid #D1D5DB",
      },
    },
    pagination: {
      style: {
        backgroundColor: "#F9FAFB",
        padding: "10px 20px",
        borderTop: "1px solid #E5E7EB",
      },
      pageButtonsStyle: {
        borderRadius: "4px",
        height: "30px",
        width: "30px",
        padding: "6px",
        margin: "0 5px",
        cursor: "pointer",
        transition: "all 0.2s ease",
        color: "#1F2937",
        "&:hover": {
          backgroundColor: "#E5E7EB",
        },
        "&:disabled": {
          backgroundColor: "#E5E7EB",
          color: "#9CA3AF",
          cursor: "not-allowed",
        },
      },
    },
  };
  return (
    <div className="p-8">
      <h1 className="text-2xl font-bold mb-4">Complaints</h1>

      <div className="flex items-center space-x-4 mb-4">
        <select
          className="form-select me-3"
          value={searchField}
          onChange={handleSearchFieldChange}
          style={{ width: "auto", minWidth: "150px" }}
        >
          <option value="contact">Contact</option>
          <option value="lastModified">Last Modified</option>
        </select>

        <input
          type="text"
          placeholder={`Search by ${searchField}...`}
          value={searchTerm}
          onChange={handleSearchTermChange}
          className="form-control"
          style={{ width: "60%" }}
        />
      </div>

      <div className="shadow rounded overflow-hidden">
        <DataTable
          columns={columns}
          data={filteredComplaints}
          customStyles={customStyles}
          pagination
          highlightOnHover
          dense
        />
      </div>

      <div
        className="modal fade"
        id="complaintModal"
        tabIndex="-1"
        aria-labelledby="complaintModalLabel"
        aria-hidden="true"
        onHide={handleModalClose}
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="complaintModalLabel">
                Complaint Details
              </h5>
              <div
                style={{
                  width: "20%",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <button
                  type="button"
                  className="btn btn-warning"
                  data-bs-dismiss="modal"
                  onClick={() =>
                    updateComplaint(
                      selectedComplaint.contact,
                      "Case closed by admin",
                      "Closed"
                    )
                  }
                >
                  Close Case
                </button>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={handleModalClose}
                ></button>
              </div>
            </div>
            <div className="modal-body">
              {selectedComplaint && (
                <div>
                  <div
                    style={{
                      maxHeight: "670px",
                      overflowY: "auto",
                      backgroundColor: "#f8f9fa",
                      borderRadius: "5px",
                      padding: "10px",
                    //   backgroundImage: url(${backgroundImage}),
                    }}
                    className="bg-no-repeat bg-cover"
                  >
                    {selectedComplaint.messages.map((msg, index) => {
                      const messageDate = new Date(
                        msg.timeStamp.seconds * 1000
                      );
                      const messageDateString = format(
                        messageDate,
                        "EEEE, dd MMMM yyyy"
                      );
                      const messageTimeString = format(messageDate, "hh:mm a");
                      const showSeparator =
                        index === 0 ||
                        messageDateString !==
                          format(
                            new Date(
                              selectedComplaint.messages[index - 1].timeStamp
                                .seconds * 1000
                            ),
                            "EEEE, dd MMMM yyyy"
                          );

                      return (
                        <React.Fragment key={index}>
                          {showSeparator && (
                            <MessageSeparator
                              as="h2"
                              content={messageDateString}
                              className="bg-indigo-100"
                            />
                          )}
                          <div
                            className={`flex ${
                              isUserMessage(msg.sender)
                                ? "flex-col gap-2"
                                : "justify-end"
                            } py-0 mx-2`}
                          >
                            <div className="flex flex-col gap-1 w-full max-w-2xl">
                              <div
                                className={`p-2 py-1 rounded-lg w-fit max-w-full md:max-w-md lg:max-w-lg ${
                                  isUserMessage(msg.sender)
                                    ? "bg-white"
                                    : "ml-auto bg-teal-100"
                                }`}
                              >
                                {msg.type === "text" ? (
                                  <div>
                                    <p className="px-2 text-md">{msg.text}</p>
                                    <p className="text-xs mt-1 ml-auto w-fit">
                                      {messageTimeString}
                                    </p>
                                  </div>
                                ) : msg.type === "file" ? (
                                  msg.filename &&
                                  msg.filename.endsWith(".mp4") ? (
                                    <div className="w-full relative max-w-[400px]">
                                      <video
                                        src={msg.downloadUrl}
                                        controls
                                        className="w-full h-full object-scale-down"
                                      />
                                      <p className="text-xs mt-1 ml-auto w-fit">
                                        {messageTimeString}
                                      </p>
                                    </div>
                                  ) : (
                                    <div className="w-full relative max-w-[300px] md:max-w-lg">
                                      <img
                                        src={msg.downloadUrl}
                                        className="w-full h-full object-scale-down"
                                        alt="sent media"
                                      />
                                      <p className="text-xs mt-1 ml-auto w-fit">
                                        {messageTimeString}
                                      </p>
                                    </div>
                                  )
                                ) : null}
                              </div>
                              <div ref={messagesEndRef} />
                            </div>
                          </div>
                        </React.Fragment>
                      );
                    })}
                  </div>
                  <div />
                  <hr />
                  <section className="h-16 bg-white flex items-center px-3">
                    <div className="relative">
                      <button
                        onClick={handleUploadImageVideoOpen}
                        className="flex justify-center items-center w-11 h-11 rounded-full hover:bg-[#05adb5] hover:text-white"
                      >
                        <FaPlus size={20} />
                      </button>
                      {openImageVideoUpload && (
                        <div className="bg-white shadow rounded absolute bottom-14 w-36 p-2">
                          <form>
                            <label
                              htmlFor="uploadImage"
                              className="flex items-center p-2 px-3 gap-3 hover:bg-slate-200 cursor-pointer"
                            >
                              <div className="text-primary">
                                <FaImage size={18} />
                              </div>
                              <p>Media</p>
                            </label>
                            <input
                              type="file"
                              id="uploadImage"
                              onChange={handleFileChange}
                              className="hidden"
                              accept="image/,video/"
                            />
                          </form>
                        </div>
                      )}
                    </div>

                    <div className="h-full w-full flex gap-1">
                      <div
                        id="allmessagesclick"
                        style={{ display: "none" }}
                        onClick={() => {
                          messagesEndRef.current.scrollIntoView({
                            behavior: "smooth",
                            block: "end",
                          });
                        }}
                      >
                        Click me
                      </div>
                      <input
                        type="text"
                        placeholder="Type here message..."
                        value={newComment}
                        onChange={(e) => setNewComment(e.target.value)}
                        className="py-1 px-4 w-full h-full"
                      />
                      <button
                        className="text-primary hover:text-secondary"
                        onClick={handleSendComment}
                      >
                        <IoMdSend size={28} />
                      </button>
                    </div>
                  </section>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}